import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './LotteryNumberGenerator.css'
import { LOTTERY_GAMES, generateLotteryNumbers } from './utils/lotteryGenerator'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const LotteryNumberGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Números da Sorte: Mega-Sena e Lotofácil | jarder.dev',
    description:
      'Gere jogos aleatórios de Mega-Sena, Lotofácil, Quina e Lotomania. ' +
      'Grátis, só pra diversão, não aumenta suas chances de ganhar.',
  })

  const [game, setGame] = useState('megasena')
  const [games, setGames] = useState([])

  const generate = () => {
    setGames((current) => [generateLotteryNumbers(game), ...current].slice(0, 10))
    trackEvent('tool_generate', { tool: 'lottery_generator', game })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de Números da Sorte</h1>
      <p className="tool-disclaimer">
        Números totalmente aleatórios, gerados no seu navegador. É só
        diversão, não existe estratégia que aumente as chances reais de
        ganhar.
      </p>

      <div className="tool-field">
        <label htmlFor="game">Jogo</label>
        <select id="game" value={game} onChange={(e) => setGame(e.target.value)}>
          {Object.entries(LOTTERY_GAMES).map(([key, g]) => (
            <option key={key} value={key}>
              {g.label} ({g.pick} números de {g.max})
            </option>
          ))}
        </select>
      </div>

      <button type="button" className="tool-button" onClick={generate}>
        Gerar jogo
      </button>

      {games.length > 0 && (
        <div className="lottery-games" style={{ marginTop: 20 }}>
          {games.map((numbers, i) => (
            <div className="lottery-game-row" key={i}>
              {numbers.map((n) => (
                <span className="lottery-ball" key={n}>
                  {String(n).padStart(2, '0')}
                </span>
              ))}
            </div>
          ))}
        </div>
      )}

      <div className="tool-info-section">
        <h2>Sobre os jogos</h2>
        <p>
          Cada jogo segue a faixa de números e a quantidade de dezenas
          sorteadas das loterias da Caixa: a Mega-Sena pede 6 números de
          1 a 60, a Lotofácil 15 números de 1 a 25, e assim por diante.
          Os números aqui são sorteados aleatoriamente no seu navegador
          e servem só como sugestão de jogo  não têm relação nenhuma com
          os sorteios oficiais nem aumentam a probabilidade de acertar.
        </p>
      </div>
    </div>
  )
}

export default LotteryNumberGenerator
